<div class="bp-modal mw-900" [class.elevated]="!isVerificationMandatory">
  <bp-modal-header [title]="'select_trade_type_header' | translate">
    <a right (click)="close()" class="large-weight" (keydown.enter)="close()" [tabIndex]="0">
      {{ "abort" | translate }}
    </a>
  </bp-modal-header>
  <div class="bp-modal-body">
    <div class="bp-modal-body-section">
      @if (isVerificationMandatory) {
        <verification-start></verification-start>
      } @else {
        <div class="ml-15 mr-15 mb-30 text-center title">
					<!-- Copy change needed for UK -->
					{{ "uk_header_buy_sell_coins_redeem_voucher" | translate }}
        </div>
        <div class="container-flex-columns container-flex-columns--tradedecision center-horizontal mb-30">
          <!-- BUY -->
          <!--CHECKOUT FLOW-->
          @if (showCheckoutFlow$ | async) {
            <div class="trade-card ml-15 mr-15">
              <div
                class="symbol-text-tile mb-30"
                (click)="!isVerificationMandatory && answer('checkout')"
                data-placement="top"
                bp-tooltip="{{ actionTooltip('buy') | translate }}"
                position="top"
							[ngClass]="{
								'is-muted': isVerificationMandatory
							}">
                <div class="symbol-text-tile-icon-container">
                  <span class="symbol-text-tile-icon bpi__icon-buy"></span>
                </div>
                <div class="symbol-text-tile-text">{{ "trade_type_decision_buy" | translate }}</div>
              </div>
            </div>
          } @else {
            <div class="trade-card ml-15 mr-15">
              <div
                class="symbol-text-tile mb-30"
                (click)="!isVerificationMandatory && answer('buy')"
                data-placement="top"
                bp-tooltip="{{ actionTooltip('buy') | translate }}"
                position="top"
								[ngClass]="{
									'is-muted': isVerificationMandatory
								}">
                <div class="symbol-text-tile-icon-container">
                  <span class="symbol-text-tile-icon bpi__icon-buy"></span>
                </div>
                <div class="symbol-text-tile-text">{{ "trade_type_decision_buy" | translate }}</div>
              </div>
            </div>
          }
          <!-- LEGACY BUY FLOW -->
          <!-- SELL -->
          <div class="trade-card ml-15 mr-15">
            <div
              class="symbol-text-tile mb-30"
              (click)="!isVerificationMandatory && answer('sell')"
              data-placement="top"
              bp-tooltip="{{ actionTooltip('sell') | translate }}"
              position="top"
							[ngClass]="{
								'is-muted': !canSell || isVerificationMandatory
							}">
              <div class="symbol-text-tile-icon-container">
                <span class="symbol-text-tile-icon bpi__icon-sell"></span>
              </div>
              <div class="symbol-text-tile-text">{{ "sell" | translate }}</div>
            </div>
          </div>
          <!-- SWAP -->
          @if (!isSwapDisabled() || isVerificationMandatory) {
            <div class="trade-card ml-15 mr-15">
              <div
                class="symbol-text-tile mb-30"
                (click)="!isVerificationMandatory && answer('swap')"
                data-placement="top"
                bp-tooltip="{{ actionTooltip('swap') | translate }}"
                position="top"
                [ngClass]="{ 'is-muted': isMuted }">
                <div class="symbol-text-tile-icon-container">
                  <span class="symbol-text-tile-icon bpi__icon-swap"></span>
                </div>
                <div class="symbol-text-tile-text">{{ "swap" | translate }}</div>
              </div>
            </div>
          }
          <!-- LEVERAGE -->
          @if (shouldDisplayLeveragePill$ | async) {
            <div class="trade-card ml-15 mr-15">
              <a
                class="symbol-text-tile mb-30"
                (click)="!isVerificationMandatory && answer('leverage')"
                data-placement="top"
                bp-tooltip="{{ actionTooltip('leverage') | translate }}"
                position="top">
                <div class="flex justify-center">
                  <bp-icon icon="arrow-up-right" size="48" />
                </div>
                <div class="symbol-text-tile-text">
                  {{ "currency_filter_leveraged_tokens" | translate }}
                </div>
              </a>
            </div>
          }
          <!-- RECURRING BUY -->
          @if (!savingsDisabled || isVerificationMandatory) {
            <div class="trade-card ml-15 mr-15">
              <div
                class="symbol-text-tile mb-30"
                (click)="!isVerificationMandatory && answer('recurring-buy')"
                data-placement="top"
                bp-tooltip="{{ actionTooltip('savings') | translate }}"
                position="top"
                [ngClass]="{ 'is-muted': isVerificationMandatory }">
                <div class="symbol-text-tile-icon-container">
                  <span class="symbol-text-tile-icon bpi__icon-savings"></span>
                </div>
                <div class="symbol-text-tile-text">
                  {{ "recurring_buy_decision_modal_buy" | translate }}
                </div>
              </div>
            </div>
          }
          <!--STAKING-->
          <div class="trade-card ml-15 mr-15" *featureVisibility="featureList.STAKING">
            <div
              class="symbol-text-tile mb-30"
              (click)="answer('stake')"
              [class.is-muted]="(isStakingEnabled$ | async) === false">
              <div class="symbol-text-tile-icon-container">
                <svg-inline src="assets/images/staking/stake_cta.svg" class="w-40" />
              </div>
              <div class="symbol-text-tile-text">{{ "stake" | translate }}</div>
            </div>
          </div>
        </div>
        @if (!canBuy) {
          <div class="modal-add-info mb-30">
            <h3 class="modal-add-info-headline">{{ "make_deposit_header" | translate }}</h3>
            <p class="modal-add-info-text text-narrowest center-block">
              <!-- Copy change needed for UK -->
							{{ "make_deposit_detail_information_uk" | translate }}
            </p>
            <button
              class="deposit-now-button modal-add-info-button btn btn-primary btn-bigger-text"
              type="button"
              (click)="deposit()">
              {{ "make_deposit_button" | translate }}
            </button>
          </div>
        }
      }
    </div>
  </div>
</div>
